// components/.../GeneratedPurchaseOrder/Header/index.jsx
import { Grid, Typography, Box } from "@mui/material";
import styles from './index.module.css';
import { formatPresentationDate } from "../../../../utils/common";

const LOGO = 'https://elitepromomarketing.com/wp-content/uploads/2024/08/logo-1-600x183.png';

/**
 * Props:
 * - poNumber: string (e.g. "PO208-1")
 * - poDate:   string | Date (use createdAt or inhandsDate)
 * - supplierName: string (from purchaseOrderDetails.supplierInfo.supplierName)
 * - isLoaded: boolean (true when PO is fetched)
 *
 * Back-compat fallbacks (if you keep old props around):
 * - id -> used if poNumber missing
 * - presentationDate -> used if poDate missing
 * - Introduction -> used if supplierName missing
 */
const Header = ({
  poNumber,
  poDate,
  supplierName,
  isLoaded = false,
  headerConfig,
  // legacy / fallbacks:
  id,
  presentationDate,
  Introduction
}) => {
  const effectiveNumber = poNumber || id || '—';
  const effectiveDate = poDate || presentationDate || null;
  const effectiveSupplier = supplierName || Introduction || '';

  const formattedDate = effectiveDate ? formatPresentationDate(effectiveDate) : '';
  const showMeta = Boolean(isLoaded && formattedDate);
  const resolvedLogo = headerConfig?.logoUrl || LOGO;
  const companyName = headerConfig?.companyName || 'Elite Promotional Marketing';

  const headerStyle = {
    backgroundImage: headerConfig?.backgroundUrl ? `url('${headerConfig.backgroundUrl}')` : undefined,
    backgroundColor: headerConfig?.backgroundColor || undefined,
  };

  return (
    <Grid container className={styles.headerContainer} style={headerStyle}>
      {/* Logo */}
      <Grid item xs={1.5} className={styles.headerLogoContainer}>
        <img src={resolvedLogo} className={styles.headerLogo} alt="Logo" />
      </Grid>

      {/* Title + Meta */}
      <Grid item xs={5} className={styles.TitleContainer}>
        <Box>
          <Typography variant="h4" gutterBottom color="white">
            {companyName}
          </Typography>

          {/* Reserve the space; reveal meta when data is loaded */}
          <Typography
            variant="body1"
            color="white"
            sx={{ visibility: showMeta ? 'visible' : 'hidden' }}
          >
            {/* First line: "Purchase Order #PO208-1 for Supplier Name" */}
            {`Purchase Order #${effectiveNumber}`}
            {effectiveSupplier ? ` for ${effectiveSupplier}` : ''}
            <br />
            {/* Second line: "{date} - Promotional Items" */}
            {formattedDate} - Promotional Items
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Header;
